import type { ComponentType } from 'react';
import Component from './CommissionCreateButton';
import Container, { OwnProps } from './CommissionCreateButton.container';

export default Container(Component) as ComponentType<OwnProps>;
